import * as Yup from 'yup';

import { userFields, trackFields, socialLinkFields } from '@/config/validations';

const { fullName, displayName, bio, email } = userFields;
const { trackName } = trackFields;
const { link } = socialLinkFields;

export const getEmailRules = (emailValidationMessageKey: string) =>
  Yup.string()
    .trim()
    .ensure()
    .email(emailValidationMessageKey)
    .required('errors.form.email.required')
    .max(email.max, { key: 'errors.form.tooBig', vars: { number: email.max } });

export const emailRules = getEmailRules('errors.form.email.invalid');

export const fullNameRules = Yup.string()
  .trim()
  .ensure()
  .required('errors.form.fullName.required')
  .min(fullName.min, { key: 'errors.form.tooShort', vars: { number: fullName.min } })
  .max(fullName.max, { key: 'errors.form.tooBig', vars: { number: fullName.max } });

export const displayNameRules = Yup.string()
  .trim()
  .min(displayName.min, {
    key: 'errors.form.displayName.tooShort',
    vars: { number: displayName.min },
  })
  .max(displayName.max, {
    key: 'errors.form.displayName.tooBig',
    vars: { number: displayName.max },
  })
  .nullable();

export const bioRules = Yup.string()
  .trim()
  .max(bio.max, { key: 'errors.form.tooBig', vars: { number: bio.max } })
  .nullable();

export const urlRules = Yup.string()
  .matches(
    /((https?):\/\/)(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9+&@#%?=~_|!:,.;-]+)*\/?(\?[a-zA-Z0-9+&@#%?=~_|!:,.;-]+=[a-zA-Z0-9-%]+&?)?$/,
    'errors.form.incorrectUrlFormat',
  )
  .max(link.max, { key: 'errors.form.tooBig', vars: { number: link.max } });

export const trackNameRules = Yup.string()
  .trim()
  .max(trackName.max, { key: 'errors.form.tooBig', vars: { number: trackName.max } })
  .matches(/^[^/]*$/, '"/" is not allowed')
  .required('errors.form.required');

export const isTrackNameValid = (param: string): boolean => {
  try {
    trackNameRules.validateSync(param);

    return true;
  } catch (err) {
    return false;
  }
};
